// extracted by mini-css-extract-plugin
module.exports = {"contentOffset":"layout-module--contentOffset--2WsSn"};